import { api } from '@bilibili-maoer/web-utils';

var FEED_PAGE_URL = "".concat(api.MISSEVAN_SITE_MAIN, "/mperson/homepage"); // 历史主页 url

var HISTORY_PAGE_URL = "".concat(api.MISSEVAN_SITE_MAIN, "/mperson/history");

export { FEED_PAGE_URL, HISTORY_PAGE_URL };
